module.exports = __webpack_public_path__ + "img/workorderBanner.b28f4c04.png";